// extracted by mini-css-extract-plugin
export default {"box":"file-image_box__xMOIi","download":"file-image_download__ECRw+","preview":"file-image_preview__ZS4Mg"};